import { render, staticRenderFns } from "./Depositos.vue?vue&type=template&id=1cbf10e6&scoped=true"
import script from "./Depositos.vue?vue&type=script&lang=js"
export * from "./Depositos.vue?vue&type=script&lang=js"
import style0 from "./Depositos.vue?vue&type=style&index=0&id=1cbf10e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf10e6",
  null
  
)

export default component.exports